export default "__VITE_ASSET__DkID1j1N__"